<template>
	<div class="container__menu">
		<MenuOptions />
		<div id="app">
			<LanguageSelector />
		</div>

		<MenuUserNotifications />
	</div>
</template>

<script>
import MenuOptions from './MenuOptions/MenuOptions'
import MenuUserNotifications from './MenuUserNotifications/MenuUserNotifications'
import LanguageSelector from '../LanguageSelector/LanguageSelector.vue'

export default {
	components: { MenuOptions, MenuUserNotifications, LanguageSelector },

	methods: {
		mudarIdioma() {
			const idioma = this.$i18n.locale === 'ptbr' ? 'es' : 'ptbr'
			localStorage.setItem('idioma', idioma)
			this.$i18n.locale = idioma
		},
	},
}
</script>

<style scoped>
.container__menu {
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	height: fit-content;
	display: flex;
	justify-content: space-between;
	padding: 0 2rem;
	align-items: center;
	align-content: center;
}

@media screen and (min-width: 1200px) {
	.container__menu {
		padding: 0;
	}
}

.container__globe__icon {
	cursor: pointer;
}
</style>
